<script>
import FlowChip from '@/components/FlowChip.vue'
import Loading from '@/components/Loading.vue'
import { EpanetSensorTipo, TipoPinoSensor } from '@/utils/constants'
import http from '@/utils/http'

export default {
  name: 'ShowSensorData',
  components: { FlowChip, Loading },
  props: {
    localId: {
      type: String,
      required: true,
    },
    sensor: {
      type: Object,
      required: true,
    },
    equipamentoId: {
      type: String,
      required: true,
    },
    status: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      deleteModal: false,
    }
  },
  computed: {
    TipoPinoSensor() {
      return TipoPinoSensor
    },
    EpanetSensorTipo() {
      return EpanetSensorTipo
    },
  },
  methods: {
    async deletar(id) {
      this.loading = true
      this.deleteModal = false

      await http.delete(`sensor`, id).finally(() => {
        this.loading = false
        this.$emit('delete', id)
      })
    },
  },
}
</script>

<template>
  <div>
    <div class="row mt-2 ml-1" />
    <div class="row" style="align-items: center">
      <div class="col-8">
        <div class="row">
          <FlowChip
            :value="status.severity"
            :config="{
              0: { label: 'Ativo', color: '#4CAF50' },
              1: { label: 'Aviso', color: '#FF9800' },
              2: { label: 'Travado', color: '#F44336' },
            }"
          />

          <FlowChip
            class="ml-1"
            :value="+sensor.visibilidadeGrafico"
            :config="{
              0: { label: 'Gráfico', color: '#F44336' },
              1: { label: 'Gráfico', color: '#4CAF50' },
            }"
          />
        </div>
      </div>

      <div class="col-4" style="text-align: right">
        <md-button @click="$emit('close')">
          <md-icon>close</md-icon>
        </md-button>
      </div>
    </div>

    <p class="md-title m-0">
      {{ sensor.descricao }}
    </p>

    <div class="row mt-3">
      <div>
        <md-button
          class="button-sensor"
          @click="
            $router.push({
              name: 'EquipamentoSensorEditar',
              params: {
                sensorId: sensor.id,
                equipamentoId: equipamentoId,
                localId: localId,
              },
            })
          "
        >
          Editar
        </md-button>

        <md-button
          class="button-sensor"
          style="color: #e80000"
          @click="deleteModal = true"
        >
          Excluir
        </md-button>

        <md-progress-spinner
          v-if="loading"
          :md-diameter="50"
          :md-stroke="5"
          md-mode="indeterminate"
        />
      </div>
    </div>

    <p class="text-att">Codigo Integração</p>
    <p class="mt-0 md-body-2" style="font-size: 1rem">
      {{ sensor.codigoIntegracao }}
    </p>

    <p class="text-att">Descrição</p>
    <p class="mt-0 md-body-2" style="font-size: 1rem">
      {{ sensor.descricao }}
    </p>

    <p class="text-att">Tipo Pino</p>
    <p class="mt-0 md-body-2" style="font-size: 1rem">
      {{ TipoPinoSensor[sensor.calibracao.value.tipoPino] || '-' }}
    </p>

    <p class="text-att">Soma</p>
    <p class="mt-0 md-body-2" style="font-size: 1rem">
      {{ sensor.calibracao.value.soma }}
    </p>

    <p class="text-att">Subtração</p>
    <p class="mt-0 md-body-2" style="font-size: 1rem">
      {{ sensor.calibracao.value.subtracao }}
    </p>

    <p class="text-att">Multiplicação</p>
    <p class="mt-0 md-body-2" style="font-size: 1rem">
      {{ sensor.calibracao.value.multiplicacao }}
    </p>

    <p class="text-att">Zerar menor que</p>
    <p class="mt-0 md-body-2" style="font-size: 1rem">
      {{ sensor.calibracao.value.zerarMenorQue }}
    </p>

    <p class="text-att">Média</p>
    <p class="mt-0 md-body-2" style="font-size: 1rem">
      {{ sensor.calibracao.value.media }}
    </p>

    <p class="text-att">Epanet Id</p>
    <p class="mt-0 md-body-2" style="font-size: 1rem">
      {{ sensor.epanetId || '-' }}
    </p>

    <p class="text-att">Epanet Tipo</p>
    <p class="mt-0 md-body-2" style="font-size: 1rem">
      {{ EpanetSensorTipo[sensor.epanetSensorTipo] || '-' }}
    </p>

    <p class="text-att">Cota</p>
    <p class="mt-0 md-body-2" style="font-size: 1rem">
      {{ sensor.cota || '-' }}
    </p>

    <md-dialog :md-active="deleteModal" :md-fullscreen="false">
      <md-dialog-title>Tem certeza?</md-dialog-title>
      <md-dialog-content>
        Ao deletar você irá perder os dados coletados pelo mesmo, deseja
        realmente deletar o sensor?
      </md-dialog-content>
      <md-dialog-actions>
        <md-button @click="deleteModal = false"> cancelar </md-button>
        <md-button class="md-primary" @click.stop="() => deletar(sensor.id)">
          deletar
        </md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<style scoped lang="scss">
.button-sensor {
  background-color: #eeeeee;
}

.text-att {
  font-size: 1rem;
  color: #8d8d8d;
  margin-bottom: 2px;
}
</style>
